/* panel-container.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VN91d%7Bheight%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXrulfZc%7Bbackground-color%3Avar(--ds-surface%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0aFT5vbt8w%7Bflex-direction%3Acolumn%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdRAKS%7Bposition%3Arelative%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2O5Vij7dHp%7Bflex-grow%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNO7dHp%7Bflex-shrink%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bHrqEAEMG%7Bflex-basis%3A0%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4kiQYAdnbC%7Bmin-height%3A0%7D");
import { type ReactNode } from 'react';
import { Box } from '@atlaskit/primitives/compiled/box';
import { PanelFocusLock } from '../panel-focus-lock/panel-focus-lock';
export interface PanelContainerProps {
  /**
   * The content of the panel container.
   */
  children: ReactNode;
  /**
   * A unique string that appears as data attribute `data-testid` in the rendered code, serving as a hook for automated tests.
   */
  testId?: string;
  /**
   * When `true`, a focus trap is activated so that Tab / Shift+Tab cycles only
   * through interactive elements inside the panel.
   *
   * Useful for panels that require the user to complete an action before continuing.
   *
   * @default false
   */
  isFocusLockEnabled?: boolean;
}
const styles = {
  wrapper: "_0jFU0VN91d _0KLXrulfZc _3iDTPbQ4SZ _0aFT5vbt8w _1mT5xdRAKS",
  content: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _4kiQYAdnbC"
};

/**
 * The PanelContainer component provides a standardized container for displaying content
 * in a side panel layout. It follows the design system patterns and integrates
 * with the navigation system for consistent styling and behavior.
 *
 * Compose it with a fixed `PanelHeader` / `PanelFooter` and a scrollable `PanelContent`
 * (wrapping `PanelSubheader` and `PanelBody`).
 *
 * For resizable panels, use the `PanelSplitter` from `@atlaskit/navigation-system/layout/panel-splitter`
 * alongside the `Panel` slot from `@atlaskit/navigation-system/layout/panel`.
 */
export function PanelContainer({
  children,
  testId,
  isFocusLockEnabled = false
}: PanelContainerProps): JSX.Element {
  return <PanelFocusLock isFocusLockEnabled={isFocusLockEnabled}>
			<Box as="section" testId={testId} xcss={styles.wrapper}>
				<Box xcss={styles.content}>{children}</Box>
			</Box>
		</PanelFocusLock>;
}